module.exports = __webpack_public_path__ + "img/13-doc-emissao-tipos.d3cfcc8e.png";